const _ = require('lodash')
// TODO: add structures other than listing to standardTracking,
// also can add ability to track different subsets of listing based on whether we're tracking a save vs a select based on requirements.

/**
 * This expects all fields in listing according to listingcard schema and expects it to be in listing structure that matches the same schema.
 *
 * standardTracking indicates the object which will hold the standard tracking objects for any structures needed,
 * for now just listing but conceivably other auction constructs tracking objects can be defined here.
 * @param {*} listing
 */
const listing = listing => {
  return {
    auctionNumber: _.get(listing, 'event.event_code'),
    productType: _.get(listing, 'listing_configuration.asset_type'),
    morpheusListingId: _.get(listing, 'listing_id'),
    morpheusPropertyId: _.get(listing, 'primary_property.property_id'),
    county: _.get(listing, 'seller_property.country_secondary_subdivision'),
    sellerCode: _.get(listing, 'program_configuration.program_enrollment_code'),
  }
}

const user = user => {
  return {
    userId: _.get(user, 'user_id'),
    partyId: _.get(user, 'party_id'),
  }
}

module.exports = {
  listing,
  user,
}
